import { TFunction } from "i18next";
import { validator } from "@/utils/validator";

export const createLoginSchema = (t: TFunction) =>
  validator.object().shape({
    learnerId: validator
      .string()
      .trim()
      .label(t("login.learnerId"))
      .required(t("validation.fieldRequired", { field: t("login.learnerId") })),
    password: validator
      .string()
      .trim()
      .emptyToNull()
      .autoTransformToHalfWidth()
      .label(t("login.password"))
      .required(t("validation.fieldRequired", { field: t("login.password") })),
  });
